// @ts-check

import Box from '@mui/material/Box';
import ContentBox from './ContentBox';
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import hexToRGBA from '../../util/HEXToRGBA';
import Typography from '@mui/material/Typography';
import { lightTheme } from '../../theme/themeColors';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import globalColors from '../../theme/GlobalColorsv2';

export default function FavoriteWindowToggler() {
  const palette = { ...lightTheme.palette };

  /**
   * @type {[boolean, React.Dispatch<React.SetStateAction<boolean>>]}
   */
  const [open, setOpen] = useState(false);

  /**
   * @type {Element|null}
   */
  const anchorState = null;

  /**
   * @type {[Element|null, Function]}
   */
  const [anchorEl, setAnchorEl] = useState(anchorState);

  /**
   * Toggles the display of the ContentBox popover and sets its anchor element.
   * @param {React.MouseEvent<HTMLButtonElement>} event - The event that triggered the click.
   */
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Box
        sx={{
          display: 'flex',
          width: '170px',
        }}
      >
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            margin: '0 12px !important',
            backgroundColor: globalColors.dividerColor,
          }}
        />
        <Button
          onClick={handleClick}
          aria-describedby="window-popover"
          variant="contained"
          sx={{
            backgroundColor: open ? hexToRGBA(palette.info.light, '.30') : 'initial',
            marginLeft: '0',
            boxShadow: 'none',
            padding: '0',
            width: '121px',
            '&:hover': {
              boxShadow: 'none',
              backgroundColor: hexToRGBA(palette.info.light, '.30'),
            },
            '&:hover p': {
              color: palette.info.main,
            },
            '&:hover svg path': {
              fill: palette.info.main,
            },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              textTransform: 'capitalize',
              fontWeight: 700,
              color: open ? palette.info.main : 'initial',
              fontfamily: 'articulat-cf',
              fontStyle: 'normal',
              fontSize: '14px',
            }}
          >
            All Windows
          </Typography>
          <ArrowDropDownIcon
            style={{
              transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
              color: open ? palette.info.main : 'black',
            }}
          />
        </Button>
        <ContentBox open={open} anchorEl={anchorEl} handleClose={handleClose} />
      </Box>
    </ClickAwayListener>
  );
}
